import React from "react";
import { Link, LinkProps, Theme } from "@mui/material";
import { CSSSelectorObjectOrCssVariables } from "@mui/system";

interface IProps {
  text?: string;
  color?: LinkProps["color"];
  /**
   * @default hover - this is MUI's default.
   */
  underline?: LinkProps["underline"];
  /**
   * If provided, this color will be applied to the link on hover and focus-visible states.
   * If not provided, the link will use the default MUI behavior.
   */
  hoverColor?: LinkProps["color"];
}

const SupportLink: React.FC<IProps> = ({ text = "Contact us", color = "primary", underline = "hover", hoverColor }: IProps) => {
  const sx: CSSSelectorObjectOrCssVariables<Theme> = {};
  if (hoverColor) {
    sx["&:hover, &:focus-visible"] = { color: hoverColor };
  }

  return (
    <Link sx={sx} color={color} underline={underline} href="mailto:fondhelp@biarrinetworks.com" target="_blank" rel="noopener noreferrer">
      {text}
    </Link>
  );
};

export default SupportLink;
